<script setup>
definePage({
  meta: {
    navActiveLink: 'data-review',
    action: 'review',
    subject: 'data-review',
  },
})

import Answer from "@/views/data/review/answer.vue"
import SelectAnswer from "@/views/data/review/selectAnswer.vue"

const groupId = ref("0")
const scheduleId = ref("0")
const nextScheduleId = ref("0")
const nextGroupId = ref("0")

// subject id 로..... 가져오기..... 1st 선택처리...... next도 잘하자....

const onSelectedAnswer = (gId, sId, nsId, nsgId) => {
  groupId.value = gId+""
  scheduleId.value = sId+""
  nextScheduleId.value = nsId+""
  nextGroupId.value = nsgId+""
}

const refSelectAnswer = ref()

const saveReview = () => {
  refSelectAnswer.value.fetchDatas()
}

const onVisitReviewed = () => {
  refSelectAnswer.value.fetchDatas()
}

const onNext = nsId => {
  scheduleId.value = nextScheduleId.value
  groupId.value = nextGroupId.value
  refSelectAnswer.value.fetchDatas()
}
</script>

<template>
  <VRow>
    <VCol
      cols="12"
      md="3"
    >
      <SelectAnswer
        ref="refSelectAnswer"
        :schedule-id="scheduleId"
        @select-answer="onSelectedAnswer"
        @visit-reviewed="onVisitReviewed"
      />
    </VCol>
    <VCol
      cols="12"
      md="9"
    >
      <Answer
        :group-id="groupId"
        :schedule-id="scheduleId"
        :next-schedule-id="nextScheduleId"
        :next-group-id="nextGroupId"
        @save-review="saveReview"
        @on-next="onNext"
      />
    </VCol>
  </VRow>
</template>
 